// RoleProtectedRoute.jsx
import { Navigate } from "react-router-dom";
import { useLoginContext } from "../../Contexts/LoginContext";
import LoadingScreen from "../reusable/loadingScreen.jsx"

export function RoleProtectedRoute({ children, allowedRoles }) {
  const { loggedIn, role, loading } = useLoginContext();

  if (loading) return <LoadingScreen />;

  if (!loggedIn) return <Navigate to="/login" replace />;

  return allowedRoles.includes(role) ? children : <Navigate to="/" replace />;
}